module.exports = __webpack_public_path__ + "img/cl.0f39a2b5.svg";